import React from 'react';
import { ShoppingBag, Calendar, MessageSquare, Star, DollarSign, Zap, AlertCircle, ArrowRight, Plus, Clock, CheckCircle2, TrendingUp, TrendingDown, ShieldAlert, Users, Eye, MousePointerClick, Heart, Activity, Video, FileText, Store, Settings, AlertTriangle, Play, XCircle, RefreshCw, Lightbulb, ArrowUpRight, Crown, ShieldCheck, Percent, CreditCard, Package } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { usePackages } from '../../contexts/PackagesContext';
interface OverviewTabProps {
  showToast: (msg: string) => void;
  setActiveTab: (tab: string) => void;
}
export function OverviewTab({
  showToast,
  setActiveTab
}: OverviewTabProps) {
  const {
    activePackages,
    totalRemaining,
    totalUsed
  } = usePackages();
  const hasActivePackage = activePackages.length > 0;
  const oldestPackage = activePackages.length > 0 ? activePackages[0] : null;
  const currentPlan = 'PRO';
  const discount = currentPlan === 'TOP' ? 20 : currentPlan === 'PRO' ? 10 : 0;
  return <div className="space-y-4 sm:space-y-6 animate-in fade-in duration-300" data-id="element-14138">
      {/* 1. ВЕРХНИЙ БЛОК (HEADER) */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 bg-white p-4 sm:p-5 rounded-2xl border border-slate-200 shadow-sm" data-id="element-14139">
        <div data-id="element-14140">
          <div className="flex items-center gap-3 mb-1" data-id="element-14141">
            <h2 className="text-xl sm:text-2xl font-bold text-slate-900" data-id="element-14142">
              Обзор
            </h2>
            <Badge variant="pro" className="flex items-center gap-1" data-id="element-14143">
              <Crown className="w-3 h-3" data-id="element-14144" /> PRO
            </Badge>
            <Badge variant="success" className="flex items-center gap-1" data-id="element-14145">
              <ShieldCheck className="w-3 h-3" data-id="element-14146" /> Проверен
            </Badge>
          </div>
          <p className="text-slate-500 text-sm" data-id="element-14147">
            Добро пожаловать, Анна! Вот ваша сводка на сегодня.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-4 lg:gap-6 bg-slate-50 p-3 rounded-xl border border-slate-100 w-full lg:w-auto" data-id="element-14148">
          <div className="flex flex-col" data-id="element-14149">
            <span className="text-[10px] text-slate-500 uppercase font-bold tracking-wider mb-0.5" data-id="element-14150">
              Заполнение
            </span>
            <div className="flex items-center gap-2" data-id="element-14151">
              <div className="w-16 h-1.5 bg-slate-200 rounded-full overflow-hidden" data-id="element-14152">
                <div className="w-[75%] h-full bg-amber-500 rounded-full" data-id="element-14153" />
              </div>
              <span className="text-sm font-bold text-slate-900" data-id="element-14154">75%</span>
            </div>
          </div>
          <div className="w-px h-8 bg-slate-200 hidden sm:block" data-id="element-14155" />
          <div className="flex flex-col" data-id="element-14156">
            <span className="text-[10px] text-slate-500 uppercase font-bold tracking-wider mb-0.5" data-id="element-14157">
              Рейтинг
            </span>
            <div className="flex items-center gap-1" data-id="element-14158">
              <Star className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-14159" />
              <span className="text-sm font-bold text-slate-900" data-id="element-14160">4.9</span>
            </div>
          </div>
          <div className="w-px h-8 bg-slate-200 hidden sm:block" data-id="element-14161" />
          <div className="flex flex-col" data-id="element-14162">
            <span className="text-[10px] text-slate-500 uppercase font-bold tracking-wider mb-0.5" data-id="element-14163">
              Конверсия
            </span>
            <div className="flex items-center gap-1" data-id="element-14164">
              <Percent className="w-4 h-4 text-emerald-500" data-id="element-14165" />
              <span className="text-sm font-bold text-slate-900" data-id="element-14166">12.4%</span>
            </div>
          </div>
        </div>
      </div>

      {/* 1.1 ДИНАМИЧЕСКИЙ БЛОК ЗАПОЛНЕНИЯ ПРОФИЛЯ */}
      <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-2xl p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 shadow-sm" data-id="element-14167">
        <div className="flex items-start gap-3" data-id="element-14168">
          <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-14169">
            <AlertCircle className="w-5 h-5 text-amber-600" data-id="element-14170" />
          </div>
          <div data-id="element-14171">
            <h4 className="text-sm sm:text-base font-bold text-amber-900" data-id="element-14172">
              Профиль заполнен не полностью (вы теряете ~30% заказов)
            </h4>
            <div className="flex flex-wrap gap-2 mt-2" data-id="element-14173">
              <button onClick={() => setActiveTab('profile')} className="flex items-center gap-1.5 text-xs font-medium text-amber-800 bg-amber-200/50 px-3 py-1.5 rounded-lg hover:bg-amber-300/50 transition-colors" data-id="element-14174">
                <Video className="w-3.5 h-3.5" data-id="element-14175" /> Добавить видео-визитку
              </button>
              <button onClick={() => setActiveTab('reviews')} className="flex items-center gap-1.5 text-xs font-medium text-amber-800 bg-amber-200/50 px-3 py-1.5 rounded-lg hover:bg-amber-300/50 transition-colors" data-id="element-14176">
                <Star className="w-3.5 h-3.5" data-id="element-14177" /> Собрать еще 3 отзыва
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN GRID */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 sm:gap-6" data-id="element-14178">
        {/* ЛЕВАЯ КОЛОНКА (Основной фокус) */}
        <div className="lg:col-span-8 flex flex-col gap-4 sm:gap-6 min-w-0" data-id="element-14179">
          {/* 0.5 ПАКЕТЫ ОТЧЕТОВ */}
          <Card className="p-5 border-indigo-100 bg-gradient-to-r from-indigo-50/50 to-purple-50/50 shadow-sm relative overflow-hidden" data-id="element-14180">
            <div className="absolute top-0 left-0 w-1 h-full bg-indigo-500" data-id="element-14181" />
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-14182">
              <div className="flex items-center gap-4" data-id="element-14183">
                <div className="w-12 h-12 rounded-xl bg-indigo-100 flex items-center justify-center text-indigo-600 shadow-sm flex-shrink-0" data-id="element-14184">
                  <Package className="w-6 h-6" data-id="element-14185" />
                </div>
                <div data-id="element-14186">
                  <h3 className="text-sm font-bold text-slate-900 mb-1 flex items-center gap-2" data-id="element-14187">
                    Пакеты отчетов
                    {discount > 0 && <span className="text-[10px] font-bold text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded-full" data-id="element-14188">
                        Скидка {discount}%
                      </span>}
                  </h3>
                  <div className="flex items-center gap-3 text-xs" data-id="element-14189">
                    <span className="text-emerald-600 font-medium" data-id="element-14190">
                      Осталось: {totalRemaining}
                    </span>
                    <span className="text-slate-400" data-id="element-14191">•</span>
                    <span className="text-slate-500" data-id="element-14192">
                      Использовано: {totalUsed}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex gap-2" data-id="element-14193">
                <Button size="sm" variant="outline" onClick={() => setActiveTab('packages')} data-id="element-14194">
                  Купить пакет
                </Button>
                <Button size="sm" onClick={() => setActiveTab('packages')} data-id="element-14195">
                  История
                </Button>
              </div>
            </div>
          </Card>

          {/* 1. ПРОБЛЕМЫ И РИСКИ (CRITICAL) */}
          <Card padding="md" className="border-rose-300 bg-rose-50/80 shadow-sm relative overflow-hidden" data-id="element-14196">
            <div className="absolute top-0 left-0 w-1 h-full bg-rose-500" data-id="element-14197" />
            <div className="flex items-center gap-2 mb-4" data-id="element-14198">
              <ShieldAlert className="w-6 h-6 text-rose-600" data-id="element-14199" />
              <h3 className="text-lg font-bold text-rose-900" data-id="element-14200">
                Требует срочного внимания
              </h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-14201">
              <div className="bg-white border border-rose-200 p-3 sm:p-4 rounded-xl flex flex-col xs:flex-row items-start xs:items-center justify-between shadow-sm gap-3 min-w-0 overflow-hidden" data-id="element-14202">
                <div className="flex items-center gap-3 min-w-0 flex-1" data-id="element-14203">
                  <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center text-rose-600 font-bold text-lg shrink-0" data-id="element-14204">
                    2
                  </div>
                  <div className="min-w-0" data-id="element-14205">
                    <div className="text-sm font-bold text-slate-900 truncate" data-id="element-14206">
                      Сообщения без ответа
                    </div>
                    <div className="text-xs text-rose-600 flex items-center mt-0.5" data-id="element-14207">
                      <Clock className="w-3 h-3 mr-1 shrink-0" data-id="element-14208" /> более 24 часов
                    </div>
                  </div>
                </div>
                <Button variant="outline" size="sm" className="text-rose-600 border-rose-200 hover:bg-rose-50 shrink-0 w-full xs:w-auto" onClick={() => setActiveTab('chat')} data-id="element-14209">
                  Ответить
                </Button>
              </div>
              <div className="bg-white border border-rose-200 p-3 sm:p-4 rounded-xl flex flex-col xs:flex-row items-start xs:items-center justify-between shadow-sm gap-3 min-w-0 overflow-hidden" data-id="element-14210">
                <div className="flex items-center gap-3 min-w-0 flex-1" data-id="element-14211">
                  <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center text-rose-600 font-bold text-lg shrink-0" data-id="element-14212">
                    1
                  </div>
                  <div className="min-w-0" data-id="element-14213">
                    <div className="text-sm font-bold text-slate-900 truncate" data-id="element-14214">
                      Просроченный заказ
                    </div>
                    <div className="text-xs text-rose-600 flex items-center mt-0.5" data-id="element-14215">
                      <AlertTriangle className="w-3 h-3 mr-1 shrink-0" data-id="element-14216" /> Риск
                      возврата
                    </div>
                  </div>
                </div>
                <Button variant="outline" size="sm" className="text-rose-600 border-rose-200 hover:bg-rose-50 shrink-0 w-full xs:w-auto" onClick={() => setActiveTab('orders')} data-id="element-14217">
                  Перейти
                </Button>
              </div>
            </div>
          </Card>

          {/* 2. НОВЫЕ ЗАКАЗЫ (Усиленный) */}
          <Card padding="md" className="border-amber-200 shadow-sm relative overflow-hidden" data-id="element-14218">
            <div className="absolute top-0 left-0 w-1 h-full bg-amber-400" data-id="element-14219" />
            <div className="flex justify-between items-center mb-4 pl-2" data-id="element-14220">
              <h3 className="text-lg font-bold text-slate-900 flex items-center gap-2" data-id="element-14221">
                <ShoppingBag className="w-5 h-5 text-amber-500" data-id="element-14222" /> Новые заказы
                <Badge variant="warning" className="ml-2" data-id="element-14223">
                  3
                </Badge>
              </h3>
              <button onClick={() => setActiveTab('orders')} className="text-sm text-indigo-600 font-medium hover:text-indigo-700 flex items-center" data-id="element-14224">
                Все заказы <ArrowRight className="w-4 h-4 ml-1" data-id="element-14225" />
              </button>
            </div>
            <div className="space-y-3" data-id="element-14226">
              {[{
              id: '1042',
              client: 'Мария В.',
              type: 'Натальная карта',
              price: '5 000 ₽',
              source: 'Реклама',
              timer: 'Осталось 1ч 15м',
              urgent: true,
              paid: true
            }, {
              id: '1041',
              client: 'Ольга П.',
              type: 'Детский гороскоп',
              price: '4 500 ₽',
              source: 'Поиск',
              timer: 'Осталось 8ч',
              urgent: false,
              paid: false
            }].map((o, i) => <div key={i} className="flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-xl border border-slate-200 hover:border-amber-300 transition-all gap-4 bg-white" data-id="element-14227">
                  <div className="flex-1" data-id="element-14228">
                    <div className="flex flex-wrap items-center gap-1.5 sm:gap-2 mb-1.5" data-id="element-14229">
                      <span className="text-xs font-mono text-slate-400" data-id="element-14230">
                        #{o.id}
                      </span>
                      <span className="text-sm font-bold text-slate-900" data-id="element-14231">
                        {o.client}
                      </span>
                      <Badge variant="neutral" size="sm" className="text-[10px]" data-id="element-14232">
                        {o.source}
                      </Badge>
                      {o.paid ? <span className="text-[10px] font-bold text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded flex items-center whitespace-nowrap" data-id="element-14233">
                          <CheckCircle2 className="w-3 h-3 mr-1 flex-shrink-0" data-id="element-14234" />
                          Оплачено
                        </span> : <span className="text-[10px] font-bold text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded flex items-center whitespace-nowrap" data-id="element-14235">
                          <CreditCard className="w-3 h-3 mr-1 flex-shrink-0" data-id="element-14236" />
                          Ждет оплаты
                        </span>}
                    </div>
                    <div className="text-xs text-slate-600 flex flex-wrap items-center gap-3" data-id="element-14237">
                      <span className="font-medium text-slate-900" data-id="element-14238">
                        {o.type}
                      </span>
                      <span className="font-bold text-emerald-600" data-id="element-14239">
                        {o.price}
                      </span>
                      <span className={`flex items-center font-bold px-2 py-0.5 rounded ${o.urgent ? 'bg-rose-100 text-rose-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-14240">
                        <Clock className="w-3 h-3 mr-1" data-id="element-14241" /> {o.timer} на ответ
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full sm:w-auto" data-id="element-14242">
                    <Button variant="outline" size="md" className="flex-1 sm:flex-none text-slate-600" onClick={() => setActiveTab('chat')} data-id="element-14243">
                      Написать
                    </Button>
                    <Button variant="primary" size="md" className="flex-1 sm:flex-none bg-amber-500 hover:bg-amber-600 text-white border-none shadow-sm" onClick={() => showToast('Заказ взят в работу')} data-id="element-14244">
                      Взять в работу
                    </Button>
                  </div>
                </div>)}
            </div>
          </Card>

          {/* 3. БЛИЖАЙШИЕ КОНСУЛЬТАЦИИ */}
          <Card padding="md" className="border-slate-200 shadow-sm relative overflow-hidden" data-id="element-14245">
            <div className="absolute top-0 left-0 w-1 h-full bg-indigo-400" data-id="element-14246" />
            <div className="flex justify-between items-center mb-4 pl-2" data-id="element-14247">
              <h3 className="text-lg font-bold text-slate-900 flex items-center gap-2" data-id="element-14248">
                <Video className="w-5 h-5 text-indigo-500" data-id="element-14249" /> Ближайшие
                консультации
              </h3>
              <button onClick={() => setActiveTab('consultations')} className="text-sm text-indigo-600 font-medium hover:text-indigo-700 flex items-center" data-id="element-14250">
                Календарь <ArrowRight className="w-4 h-4 ml-1" data-id="element-14251" />
              </button>
            </div>
            <div className="space-y-3" data-id="element-14252">
              {[{
              time: '14:00',
              client: 'Елена С.',
              type: 'Видео-разбор',
              status: 'Оплачено',
              timer: 'Через 45 мин',
              paid: true
            }, {
              time: '16:30',
              client: 'Дмитрий В.',
              type: 'Соляр',
              status: 'Не оплачено',
              timer: 'Через 3 ч',
              paid: false
            }].map((c, i) => <div key={i} className={`flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-xl border ${c.paid ? 'border-slate-200 hover:border-indigo-300' : 'border-amber-200 bg-amber-50/30'} transition-all gap-4`} data-id="element-14253">
                  <div className="flex items-center gap-4" data-id="element-14254">
                    <div className={`w-14 h-14 rounded-xl flex flex-col items-center justify-center flex-shrink-0 ${c.paid ? 'bg-indigo-50 text-indigo-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-14255">
                      <span className="text-sm font-bold" data-id="element-14256">
                        {c.time.split(':')[0]}
                      </span>
                      <span className="text-xs leading-none opacity-80" data-id="element-14257">
                        {c.time.split(':')[1]}
                      </span>
                    </div>
                    <div data-id="element-14258">
                      <div className="flex items-center gap-2 mb-1" data-id="element-14259">
                        <span className="text-sm font-bold text-slate-900" data-id="element-14260">
                          {c.client}
                        </span>
                        <Badge variant={c.paid ? 'success' : 'warning'} size="sm" data-id="element-14261">
                          {c.status}
                        </Badge>
                      </div>
                      <div className="text-xs text-slate-500 flex items-center gap-2" data-id="element-14262">
                        <span data-id="element-14263">{c.type}</span>
                        <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-14264" />
                        <span className="font-bold text-indigo-600 flex items-center" data-id="element-14265">
                          <Clock className="w-3 h-3 mr-1" data-id="element-14266" /> {c.timer}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full sm:w-auto" data-id="element-14267">
                    {c.paid ? <Button variant="primary" size="md" className="flex-1 sm:flex-none bg-indigo-600 hover:bg-indigo-700" icon={<Play className="w-4 h-4" data-id="element-14269" />} onClick={() => showToast('Запуск видеозвонка...')} data-id="element-14268">
                        Начать
                      </Button> : <Button variant="outline" size="md" className="flex-1 sm:flex-none text-rose-600 border-rose-200 hover:bg-rose-50" onClick={() => showToast('Напоминание отправлено')} data-id="element-14270">
                        Напомнить об оплате
                      </Button>}
                  </div>
                </div>)}
            </div>
          </Card>

          {/* 4. ДОХОД И KPI (Перепакованный, плотный) */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-id="element-14271">
            <Card padding="sm" className="border-slate-200 hover:border-emerald-300 hover:shadow-md transition-all cursor-pointer bg-emerald-50/30" onClick={() => setActiveTab('finances')} data-id="element-14272">
              <div className="text-xs text-slate-500 font-medium mb-1 uppercase tracking-wider" data-id="element-14273">
                Выручка (Сегодня)
              </div>
              <div className="text-xl sm:text-2xl font-bold text-slate-900 mb-1" data-id="element-14274">
                12 400 ₽
              </div>
              <div className="text-[10px] font-bold text-emerald-600 flex items-center" data-id="element-14275">
                <TrendingUp className="w-3 h-3 mr-0.5" data-id="element-14276" /> +24% к вчера
              </div>
            </Card>
            <Card padding="sm" className="border-slate-200 hover:border-emerald-300 hover:shadow-md transition-all cursor-pointer" onClick={() => setActiveTab('finances')} data-id="element-14277">
              <div className="text-xs text-slate-500 font-medium mb-1 uppercase tracking-wider" data-id="element-14278">
                Выручка (Месяц)
              </div>
              <div className="text-xl sm:text-2xl font-bold text-slate-900 mb-1" data-id="element-14279">
                348K ₽
              </div>
              <div className="text-[10px] font-bold text-emerald-600 flex items-center" data-id="element-14280">
                <TrendingUp className="w-3 h-3 mr-0.5" data-id="element-14281" /> Прогноз: 420K ₽
              </div>
            </Card>
            <Card padding="sm" className="border-slate-200 hover:border-indigo-300 hover:shadow-md transition-all cursor-pointer" onClick={() => setActiveTab('finances')} data-id="element-14282">
              <div className="text-xs text-slate-500 font-medium mb-1 uppercase tracking-wider" data-id="element-14283">
                Средний чек
              </div>
              <div className="text-xl sm:text-2xl font-bold text-slate-900 mb-1" data-id="element-14284">
                4 250 ₽
              </div>
              <div className="text-[10px] font-bold text-emerald-600 flex items-center" data-id="element-14285">
                <TrendingUp className="w-3 h-3 mr-0.5" data-id="element-14286" /> +5%
              </div>
            </Card>
            <Card padding="sm" className="border-slate-200 hover:border-blue-300 hover:shadow-md transition-all cursor-pointer" onClick={() => setActiveTab('orders')} data-id="element-14287">
              <div className="text-xs text-slate-500 font-medium mb-1 uppercase tracking-wider" data-id="element-14288">
                Заказы (Месяц)
              </div>
              <div className="text-xl sm:text-2xl font-bold text-slate-900 mb-1" data-id="element-14289">
                142
              </div>
              <div className="text-[10px] font-bold text-slate-500 flex items-center" data-id="element-14290">
                84 завершено
              </div>
            </Card>
          </div>

          {/* 5. РЕКОМЕНДАЦИИ РОСТА (ИИ) */}
          <Card padding="md" className="border-indigo-200 bg-gradient-to-br from-indigo-50/80 to-purple-50/80 shadow-sm" data-id="element-14291">
            <div className="flex items-center gap-2 mb-4" data-id="element-14292">
              <Lightbulb className="w-5 h-5 text-indigo-600" data-id="element-14293" />
              <h3 className="text-lg font-bold text-indigo-900" data-id="element-14294">
                Как увеличить доход
              </h3>
              <Badge variant="pro" className="ml-auto" data-id="element-14295">
                AI Ассистент
              </Badge>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-14296">
              <div className="bg-white p-4 rounded-xl border border-indigo-100 shadow-sm flex flex-col" data-id="element-14297">
                <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2" data-id="element-14298">
                  Высокий спрос
                </div>
                <div className="text-sm font-bold text-slate-900 mb-1" data-id="element-14299">
                  Натальная карта продается отлично
                </div>
                <p className="text-xs text-slate-600 mb-4 flex-1" data-id="element-14300">
                  Спрос вырос на 15%. Вы можете безопасно поднять цену без
                  потери клиентов.
                </p>
                <Button variant="outline" size="sm" className="text-indigo-700 border-indigo-200 hover:bg-indigo-50 w-full" onClick={() => setActiveTab('services')} data-id="element-14301">
                  Поднять цену на 10%
                </Button>
              </div>
              <div className="bg-white p-4 rounded-xl border border-indigo-100 shadow-sm flex flex-col" data-id="element-14302">
                <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2" data-id="element-14303">
                  Точка роста
                </div>
                <div className="text-sm font-bold text-slate-900 mb-1" data-id="element-14304">
                  Детский гороскоп проседает
                </div>
                <p className="text-xs text-slate-600 mb-4 flex-1" data-id="element-14305">
                  0 продаж за неделю. Включите рекламу в каталоге, чтобы
                  получить первые заказы.
                </p>
                <Button variant="primary" size="sm" className="bg-indigo-600 hover:bg-indigo-700 w-full" onClick={() => setActiveTab('promotion')} data-id="element-14306">
                  Запустить рекламу
                </Button>
              </div>
            </div>
          </Card>
        </div>

        {/* ПРАВАЯ КОЛОНКА (Вторичная) */}
        <div className="lg:col-span-4 flex flex-col gap-4 sm:gap-6 min-w-0" data-id="element-14307">
          {/* БЫСТРЫЕ ДЕЙСТВИЯ (Крупные, важные) */}
          <div className="grid grid-cols-2 gap-3" data-id="element-14308">
            <button onClick={() => setActiveTab('services')} className="flex flex-col items-center justify-center p-4 rounded-xl border border-slate-200 bg-white hover:border-indigo-300 hover:shadow-md transition-all group" data-id="element-14309">
              <div className="w-10 h-10 rounded-full bg-indigo-50 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform" data-id="element-14310">
                <Plus className="w-5 h-5 text-indigo-600" data-id="element-14311" />
              </div>
              <span className="text-sm font-bold text-slate-700 text-center" data-id="element-14312">
                Создать
                <br data-id="element-14313" />
                услугу
              </span>
            </button>
            <button onClick={() => setActiveTab('marketplace')} className="flex flex-col items-center justify-center p-4 rounded-xl border border-slate-200 bg-white hover:border-purple-300 hover:shadow-md transition-all group" data-id="element-14314">
              <div className="w-10 h-10 rounded-full bg-purple-50 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform" data-id="element-14315">
                <Store className="w-5 h-5 text-purple-600" data-id="element-14316" />
              </div>
              <span className="text-sm font-bold text-slate-700 text-center" data-id="element-14317">
                Добавить
                <br data-id="element-14318" />
                курс
              </span>
            </button>
            <button onClick={() => setActiveTab('promotion')} className="flex flex-col items-center justify-center p-4 rounded-xl border border-slate-200 bg-white hover:border-amber-300 hover:shadow-md transition-all group" data-id="element-14319">
              <div className="w-10 h-10 rounded-full bg-amber-50 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform" data-id="element-14320">
                <Zap className="w-5 h-5 text-amber-600" data-id="element-14321" />
              </div>
              <span className="text-sm font-bold text-slate-700 text-center" data-id="element-14322">
                Включить
                <br data-id="element-14323" />
                рекламу
              </span>
            </button>
            <button onClick={() => setActiveTab('profile')} className="flex flex-col items-center justify-center p-4 rounded-xl border border-slate-200 bg-white hover:border-slate-400 hover:shadow-md transition-all group" data-id="element-14324">
              <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform" data-id="element-14325">
                <Settings className="w-5 h-5 text-slate-600" data-id="element-14326" />
              </div>
              <span className="text-sm font-bold text-slate-700 text-center" data-id="element-14327">
                Настроить
                <br data-id="element-14328" />
                профиль
              </span>
            </button>
          </div>

          {/* БЛОК РЕКЛАМЫ */}
          <Card padding="md" className="border-indigo-200 bg-indigo-50/50 shadow-sm" data-id="element-14329">
            <div className="flex justify-between items-start mb-4" data-id="element-14330">
              <div data-id="element-14331">
                <h3 className="text-base font-bold text-indigo-900 flex items-center gap-2" data-id="element-14332">
                  <Zap className="w-4 h-4 text-amber-500 fill-amber-500" data-id="element-14333" />{' '}
                  Реклама активна
                </h3>
                <p className="text-xs text-indigo-700 mt-0.5" data-id="element-14334">
                  Осталось 5 дней
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 mb-4" data-id="element-14335">
              <div className="bg-white p-3 rounded-lg border border-indigo-100 shadow-sm" data-id="element-14336">
                <div className="text-[10px] text-slate-500 uppercase font-bold mb-1" data-id="element-14337">
                  Показы
                </div>
                <div className="text-lg font-bold text-slate-900" data-id="element-14338">12.4K</div>
              </div>
              <div className="bg-white p-3 rounded-lg border border-indigo-100 shadow-sm" data-id="element-14339">
                <div className="text-[10px] text-slate-500 uppercase font-bold mb-1" data-id="element-14340">
                  Клики (4.2%)
                </div>
                <div className="text-lg font-bold text-slate-900" data-id="element-14341">524</div>
              </div>
              <div className="bg-white p-3 rounded-lg border border-indigo-100 shadow-sm" data-id="element-14342">
                <div className="text-[10px] text-slate-500 uppercase font-bold mb-1" data-id="element-14343">
                  Заявки
                </div>
                <div className="text-lg font-bold text-emerald-600" data-id="element-14344">18</div>
              </div>
              <div className="bg-white p-3 rounded-lg border border-indigo-100 shadow-sm" data-id="element-14345">
                <div className="text-[10px] text-slate-500 uppercase font-bold mb-1" data-id="element-14346">
                  Доход
                </div>
                <div className="text-lg font-bold text-emerald-600" data-id="element-14347">74K ₽</div>
              </div>
            </div>

            <div className="flex flex-col gap-2" data-id="element-14348">
              <Button variant="primary" size="md" fullWidth className="bg-indigo-600 hover:bg-indigo-700 shadow-sm" onClick={() => setActiveTab('promotion')} data-id="element-14349">
                Увеличить бюджет
              </Button>
            </div>
          </Card>

          {/* АКТИВНОСТЬ ПРОФИЛЯ (Воронка) */}
          <Card padding="md" className="border-slate-200 shadow-sm" data-id="element-14350">
            <h3 className="text-base font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-14351">
              <Activity className="w-4 h-4 text-blue-500" data-id="element-14352" /> Воронка профиля (7
              дней)
            </h3>
            <div className="space-y-4" data-id="element-14353">
              <div data-id="element-14354">
                <div className="flex justify-between text-sm mb-1" data-id="element-14355">
                  <span className="text-slate-600 flex items-center gap-1.5" data-id="element-14356">
                    <Eye className="w-3.5 h-3.5" data-id="element-14357" /> Просмотры
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-14358">1,245</span>
                </div>
                <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-14359">
                  <div className="w-full h-full bg-blue-400 rounded-full" data-id="element-14360" />
                </div>
              </div>
              <div data-id="element-14361">
                <div className="flex justify-between text-sm mb-1" data-id="element-14362">
                  <span className="text-slate-600 flex items-center gap-1.5" data-id="element-14363">
                    <MousePointerClick className="w-3.5 h-3.5" data-id="element-14364" /> Клики на
                    услуги
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-14365">
                    312{' '}
                    <span className="text-xs text-slate-400 font-normal" data-id="element-14366">
                      (25%)
                    </span>
                  </span>
                </div>
                <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-14367">
                  <div className="w-[25%] h-full bg-indigo-400 rounded-full" data-id="element-14368" />
                </div>
              </div>
              <div data-id="element-14369">
                <div className="flex justify-between text-sm mb-1" data-id="element-14370">
                  <span className="text-slate-600 flex items-center gap-1.5" data-id="element-14371">
                    <Heart className="w-3.5 h-3.5" data-id="element-14372" /> В избранное
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-14373">
                    84{' '}
                    <span className="text-xs text-slate-400 font-normal" data-id="element-14374">
                      (6%)
                    </span>
                  </span>
                </div>
                <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-14375">
                  <div className="w-[6%] h-full bg-rose-400 rounded-full" data-id="element-14376" />
                </div>
              </div>
              <div data-id="element-14377">
                <div className="flex justify-between text-sm mb-1" data-id="element-14378">
                  <span className="text-slate-600 flex items-center gap-1.5" data-id="element-14379">
                    <ShoppingBag className="w-3.5 h-3.5" data-id="element-14380" /> Переходы в заказ
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-14381">
                    42{' '}
                    <span className="text-xs text-slate-400 font-normal" data-id="element-14382">
                      (3.3%)
                    </span>
                  </span>
                </div>
                <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-14383">
                  <div className="w-[3%] h-full bg-emerald-400 rounded-full" data-id="element-14384" />
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}